import { AbstractEditEntityComponent } from '@abstracts/entities/edit-entity';
import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, Injector, Input, OnInit } from '@angular/core';
import { ChargingStation } from '@models/charging-station';
import { TransactionDto } from '@dto/transactionDto';
import { UpdateStatusFirmwareRequest } from '@dto/ocpp/UpdateStatusFirmwareRequest';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { TransactionsService } from '@services/entity/transactions.service';
import { plainToClass } from 'class-transformer';
import { ToastService } from '@services/toast/toast.service';
import { interval, Subscription } from 'rxjs';
import { FormControl, FormGroup } from '@angular/forms';
import { GetConfigurationRequest } from '@dto/ocpp/getConfigurationRequest';
import { ConfigurationRequest } from '@dto/ocpp/configurationRequest';
import { UpdateFirmwareRequest } from '@dto/ocpp/UpdateFirmwareRequest';
import { FilesService } from '@services/files/files.service';

@Component({
  selector: 'app-sys-charging-station',
  templateUrl: './system-charging-station.component.html',
  styleUrls: ['./system-charging-station.component.scss'],
})
export class SysChargingStationComponent extends AbstractEditEntityComponent implements OnInit, AfterViewInit {

  public className = 'SysChargingStationComponent';
  
  @Input() entity: ChargingStation;

  public freeChargeStatus: boolean;
  public statusClass: string = '';
  public isOperatorView: boolean;
  public firmware: string = '';
  public connectorId: number = 0;
  public command: string ='GET';
  public configurable : boolean = true;
  public lastTransactions: TransactionDto[] = [];
  public firmwareFiles: string[];
  public firmwareStatus: UpdateStatusFirmwareRequest;
  private datePipe: DatePipe;
  private refreshSub: Subscription;
  private getFwStatus: Subscription;
  private isUpdating: boolean = false;
  private  date: Date;
  private fwVersion: any;
  
  constructor(
    private chargingStationsService: ChargingStationsService,
    private transactionsService: TransactionsService,
    private toastService: ToastService,
    private filesService: FilesService,
    public injector: Injector
  ) {
    super(chargingStationsService, injector);
  }

  ngOnInit() {
    this.isOperatorView = this.activatedRoute.snapshot.data['isOperatorView'];
    super.ngOnInit();
    this.isUpdating = false;
    this.chargingStationsService.getFirmwareVersion(this.primaryKey.toString()).subscribe(result => {
      this.fwVersion = result;
      this.entity.firmware = this.fwVersion.firmwareVersion;
    }, error => {
      // this.toastService.error('Keine aktive Verbindung zur Ladestation.');
      // this.formService.form.disable()
      // this.configurable = false;
    });
    if (this.entity) {
      this.entity.chargingPoints.forEach(chargingPoint => {
        this.transactionsService.getLastTransactionOfChargingPoint(this.primaryKey.toString(), chargingPoint.connectorId).subscribe(result => {
          if(result) this.lastTransactions.push(result);
        })
      })
    }

    this.getFirmwareFiles()
    this.createForm()
    this.checkLastFirmwareStatus()
  }

  createForm() {
    this.formService.form = new FormGroup({
      command: new FormControl('GET'),
      keyInput: new FormControl(''),
      valueInput: new FormControl(''),
      response: new FormControl({ value: '', disabled: true }),
      firmware: new FormGroup({
        fw: new FormControl('none')
      })
    })

    this.formService.formCreated = true;
  }

  getFirmwareFiles() {
    this.filesService.getFileList('firmware').subscribe(fileList => {
      this.firmwareFiles = [...fileList.split(';')]
    })
  }

  selectFirmware(val: string) {
    this.firmware = val;
  }

  selectConnector(val: number) {
    this.connectorId= val;
  }

  startFirmwareUpdate() {
    if (this.firmware.length >= 10) {
      this.date = new Date();
      var firmwareRequest: UpdateFirmwareRequest = {
        location: 'https://cubosgeneralstorage.blob.core.windows.net/userapp-storage/' + this.firmware,
        retries: 2,
        retrieveDate: this.date,
        retryInterval: 120
      }
    } else {
      this.toastService.warn('Sie müssen eine Firmware-Datei auswählen.');
    }

    this.chargingStationsService.updateChargingStationFirmware(firmwareRequest, this.entity.id).subscribe(response => {
      this.isUpdating = true;
      this.setRefreshFwStatus();
    })
  }

  checkLastFirmwareStatus() {
      this.chargingStationsService.getChargingStationFirmwareUpdateStatus(this.entity.id).subscribe(result => {
        this.firmwareStatus = result;
        this.isUpdating = true;
      }, error => {
        this.isUpdating = false;
      });
  }

  setRefreshFwStatus() {
    this.getFwStatus = interval(5000).subscribe((val) => {
      this.chargingStationsService.getChargingStationFirmwareUpdateStatus(this.entity.id).subscribe(result => {
        this.firmwareStatus = result;
        this.isUpdating = true;
      }, error => {
        this.isUpdating = false;

      });
    })
  }

  async SetStatus(statusId) {
    for (const chargingPoint of this.entity.chargingPoints) {
      this.chargingStationsService.SetStatus(this.primaryKey.toString(), chargingPoint.connectorId, statusId).subscribe(result => {
      }, error => {
        console.error("could not set Status for Chargingstation");
      })
    }
  }


  onSubmit(formValue) {
    if (this.formService.form.get('command').value == 'GET') {
      var getConfigurationRequest:GetConfigurationRequest = {
        keys: formValue.keyInput.split(';').map(str => str.trim())
      }
      this.chargingStationsService.getConfiguration(this.entity.id, getConfigurationRequest).subscribe(result => {
        this.formService.form.get('response').setValue(JSON.stringify(result))
        if (result == null) {
          this.toastService.warn('Konfigurationsschlüssel gab kein Wert zurück.')
        } else {
          this.toastService.success('Konfigurationsschlüssel wurde abgefragt.')
        }
      }, error => {
        this.toastService.error('Ladestation ist nicht erreichbar.');
      })
    }

    if (this.formService.form.get('command').value == 'SET') {
      var configurationRequest : ConfigurationRequest = {
        rawKeys: formValue.keyInput,
        rawValues: formValue.valueInput
      }

      this.chargingStationsService.postConfiguration(this.entity.id, configurationRequest).subscribe(result =>{
        this.formService.form.get('response').setValue(JSON.stringify(result))
        this.toastService.success('Ladestation wurde erfolgreich konfiguriert.')
      },error => {
        this.toastService.error('Ladestation konnte nicht konfiguriert werden.');
      })
    }
  }

  onCommandChange(){
    this.command = this.formService.form.get('command').value;
  }

  ngAfterViewInit() {
    window.dispatchEvent(new Event('resize'));
  }

  ngOnDestroy(): void {
    if (this.refreshSub) this.refreshSub.unsubscribe();
    if (this.getFwStatus) this.getFwStatus.unsubscribe();
  }

  initializeEntity(entity) {
    this.entity = plainToClass(ChargingStation, entity);
  }
}
